module.exports = __webpack_public_path__ + "hand.png?9c375e8a636307d1cb90264221d223b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hand.png
// module id = 70
// module chunks = 0